import { Integrations } from "@/components/integrations"

export function Index() {
  return <Integrations />
}
